import { useState } from 'react';
import VerticalLayout from '../components/layouts/VerticalLayout';
import { HorizontalTabs } from '@opendoor/mosaic';
import moment from 'moment';
import { StringParam, useQueryParam } from 'use-query-params';
import MaintenanceRequestList, {
  MaintenanceRequestListFilter,
} from '../components/maintenance/MaintenanceRequestList';

const MaintenanceInvoicePage = () => {
  // start and end period query params will be in the format of YYYY-MM-DD
  const [startPeriodOn] = useQueryParam('startPeriodOn', StringParam);
  const [endPeriodOn] = useQueryParam('endPeriodOn', StringParam);
  const [orgId] = useQueryParam('organizationId', StringParam);
  const [selectedTab, setSelectedTab] = useState(MaintenanceRequestListFilter.OUTSTANDING);

  // TODO: call validate endpoint and show error screen if error or falsy response

  const prettifiedStart = moment(startPeriodOn).format('MMM DD');
  const prettifiedEnd = moment(endPeriodOn).format('MMM DD');

  const tabs = [
    {
      title: `${MaintenanceRequestListFilter.OUTSTANDING}`,
      isActive: selectedTab === MaintenanceRequestListFilter.OUTSTANDING,
      onClick: () => {
        setSelectedTab(MaintenanceRequestListFilter.OUTSTANDING);
      },
    },
    {
      title: `${MaintenanceRequestListFilter.PENDING_OPENDOOR_REVIEW}`,
      isActive: selectedTab === MaintenanceRequestListFilter.PENDING_OPENDOOR_REVIEW,
      onClick: () => {
        setSelectedTab(MaintenanceRequestListFilter.PENDING_OPENDOOR_REVIEW);
      },
    },
    {
      title: `${MaintenanceRequestListFilter.APPROVED}`,
      isActive: selectedTab === MaintenanceRequestListFilter.APPROVED,
      onClick: () => {
        setSelectedTab(MaintenanceRequestListFilter.APPROVED);
      },
    },
    {
      title: `${MaintenanceRequestListFilter.DENIED}`,
      isActive: selectedTab === MaintenanceRequestListFilter.DENIED,
      onClick: () => {
        setSelectedTab(MaintenanceRequestListFilter.DENIED);
      },
    },
  ];

  return (
    <VerticalLayout style={styles.container}>
      <span style={styles.header}>
        Invoiceable Items: {prettifiedStart} to {prettifiedEnd}
      </span>
      <HorizontalTabs links={tabs} />
      {selectedTab === MaintenanceRequestListFilter.OUTSTANDING && (
        <VerticalLayout>
          <div style={styles.oustandingDirective}>
            Below items are not yet marked complete. Please add the required pictures and submit
            once completed.
          </div>
          <MaintenanceRequestList
            organizationId={orgId || ''}
            startPeriod={startPeriodOn || ''}
            endPeriod={endPeriodOn || ''}
            filter={MaintenanceRequestListFilter.OUTSTANDING}
          />
        </VerticalLayout>
      )}
      {selectedTab === MaintenanceRequestListFilter.PENDING_OPENDOOR_REVIEW && (
        <MaintenanceRequestList
          organizationId={orgId || ''}
          startPeriod={startPeriodOn || ''}
          endPeriod={endPeriodOn || ''}
          filter={MaintenanceRequestListFilter.PENDING_OPENDOOR_REVIEW}
        />
      )}
      {selectedTab === MaintenanceRequestListFilter.APPROVED && (
        <MaintenanceRequestList
          organizationId={orgId || ''}
          startPeriod={startPeriodOn || ''}
          endPeriod={endPeriodOn || ''}
          filter={MaintenanceRequestListFilter.APPROVED}
        />
      )}
      {selectedTab === MaintenanceRequestListFilter.DENIED && (
        <MaintenanceRequestList
          organizationId={orgId || ''}
          startPeriod={startPeriodOn || ''}
          endPeriod={endPeriodOn || ''}
          filter={MaintenanceRequestListFilter.DENIED}
        />
      )}
    </VerticalLayout>
  );
};

export default MaintenanceInvoicePage;

const styles = {
  container: {
    backgroundColor: 'white',
    // ensures that the background of the whole page is still white even if
    // there aren't enough maintenance requests in the table to fill the whole page
    minHeight: '94vh',
    height: '100%',
    width: '100%',
    display: 'flex',
    paddingLeft: '5vw',
    paddingRight: '5vw',
    paddingTop: '5vh',
  },
  header: {
    fontWeight: 600,
    fontSize: 24,
  },
  oustandingDirective: {
    borderWidth: 1,
    borderColor: '#6E6E6E',
    borderStyle: 'solid',
    borderRadius: 5,
    padding: 10,
    marginTop: '2vh',
  },
};
